import { i as p } from "../separate-component-helper-chunks/reactive-element-BDpydG15.js";
import { html as h, nothing as c } from "../beacon-html.d/index.js";
import "../separate-component-helper-chunks/lit-element-DC8UPTKS.js";
import { property as u } from "../beacon-property.d/index.js";
import { state as v } from "../beacon-state.d/index.js";
import { ifDefined as f } from "../beacon-if-defined.d/index.js";
import { live as g } from "../beacon-live.d/index.js";
import { html as w } from "../beacon-static-html.d/index.js";
import { B as y } from "../separate-component-helper-chunks/form-base-6uTDnSZ3.js";
import { B as $ } from "../separate-component-helper-chunks/beacon-primitive-ChVMWFlW.js";
import { a as k, c as m, d as x } from "../separate-component-helper-chunks/query-assigned-DZ4JAxBy.js";
const C = p`label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}select{-webkit-appearance:none;-moz-appearance:none;appearance:none;block-size:var(--beacon-form-field-size-block);cursor:pointer;font-size:var(--beacon-form-font-size);inline-size:var(--dropdown-custom-width, 100%);line-height:var(--beacon-form-font-line-height);margin-block-start:var(--beacon-unit-subatomic);background-color:var(--beacon-form-field-color-background);background-image:url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1L5 5L1 1' stroke='%23086EA1' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");background-position:right var(--beacon-unit-base) top 50%;background-repeat:no-repeat;border-color:var(--beacon-form-field-color-border);border-radius:var(--beacon-form-field-size-border-radius);border-style:solid;border-width:var(--beacon-form-field-size-border-width-default);padding-inline-end:calc(2 * var(--beacon-unit-base) + var(--beacon-unit-atomic));padding-inline-start:var(--beacon-form-field-space-padding)}select.error{border:var(--beacon-form-field-size-border-width-error) solid var(--beacon-form-field-color-border-error)}select:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal));position:relative;z-index:1}select[aria-disabled=true]{background-image:url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1L5 5L1 1' stroke='%23929BA3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")}`;
var z = Object.defineProperty, a = (s, e, t, l) => {
  for (var o = void 0, n = s.length - 1, d; n >= 0; n--)
    (d = s[n]) && (o = d(e, t, o) || o);
  return o && z(e, t, o), o;
};
const b = "beacon-dropdown", E = ["beacon-error"], i = class i extends $(y) {
  constructor() {
    super(...arguments), this.beaconTagName = b, this.focusOverride = !0, this.name = "dropdown", this.selected = "";
  }
  static get styles() {
    return [super.styles, C];
  }
  /**
   * Change the state and value based what option is currently selected
   *
   * On initial load, this.value will be either '' (default) or the value of the option with `[selected]`
   */
  setSelectedState() {
    for (const e of this.renderedOptions)
      e.hasAttribute("selected") && (this.value = e.value, this.selected = this.value);
  }
  /**
   * Any time the slot changes with more `<option>` or `<optgroup>` elements, append them to the `<select>`
   */
  handleSlotchange() {
    this.options.length ? this.optgroups.length || this.select.append(...this.options) : this.select.append(...this.optgroups), this.setSelectedState();
  }
  /**
   * Update the dropdown's internal option selected state when changing this.value
   *
   * If an external script attempts to change this component's value, this method will run. It will verify that the dynamically-chosen value aligns with the available values in this.renderedOptions before setting the prop.
   *
   * If the desired value does not exist in the list of available options, the value does not get set.
   *
   * @throws Chosen value is not available
   * @returns Selected state change
   */
  async handleValueChange() {
    var e;
    try {
      await this.updateComplete;
      const t = Array.from(this.renderedOptions).map((l) => l.value);
      if (this.value && !t.includes(this.value))
        throw this.value = this.selected, new Error("Chosen value is not available in the dropdown options.");
      (e = this.internals) == null || e.setFormValue(this.value), this.select.value = this.value;
    } catch (t) {
      console.error(t);
    }
  }
  handleInput(e) {
    super.handleInput(e), this.selected = this.value;
  }
  render() {
    var e, t;
    return this.invalid = !((e = this.internals) != null && e.checkValidity()), h`
      <label for="dropdown">${this.label}</label>
      ${this.hint ? h`<p class="hint" id="hint">${this.hint}</p>` : c}
      ${this.invalid ? w`<${this.getScopedTag("beacon-error")} message="${(t = this.internals) == null ? void 0 : t.validationMessage}" id="error"></${this.getScopedTag(
      "beacon-error"
    )}>` : c}
      <select
        id="dropdown"
        name=${this.name}
        class="${this.invalid ? "error" : ""} form-anchor"
        aria-describedby="${f(
      this.hint || this.invalid ? [this.hint ? "hint" : "", this.invalid ? "error" : ""].join(" ").trim() : void 0
    )}"
        aria-disabled=${this.disabled}
        aria-invalid=${this.invalid}
        ?required=${this.required}
        ?disabled=${this.disabled}
        value=${g(this.value)}
        @blur=${this.handleBlur}
        @change=${this.handleChange}
        @click=${this.emitClick}
        @focus=${this.emitFocus}
        @input=${this.handleInput}
        @keydown=${this.handleKeydown}
        @mousedown=${this.handleMousedown}
      ></select>
      <slot @slotchange="${this.handleSlotchange}"></slot>
    `;
  }
  willUpdate(e) {
    this.handleValueChange();
  }
};
i.tagName = b, i.nestedComponents = E;
let r = i;
a([
  u({ reflect: !0 })
], r.prototype, "name");
a([
  v()
], r.prototype, "selected");
a([
  k("select#dropdown")
], r.prototype, "select");
a([
  m({ flatten: !0, selector: "option" })
], r.prototype, "options");
a([
  m({ flatten: !0, selector: "optgroup" })
], r.prototype, "optgroups");
a([
  x("option")
], r.prototype, "renderedOptions");
export {
  r as BeaconDropdown
};
